<template>
  <div>
    <Head></Head>
    <Navbar activeMenu="网络演出剧（节）目" />
    <Banner></Banner>
    <div class="main">
      <div class="container">
        <div
          v-for="(item, index) in videos"
          :key="index"
          class="video-item"
          @click="$router.push(`/videoPlay/${item.id}`)"
        >
          <div class="cover">
            <img
              :src="item.cover"
              class="cover-image"
            />
            <div class="mask"></div>
          </div>
          <p class="title">{{ item.title }}</p>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Head from './index/Head';
import Navbar from './index/Navbar.vue';
import Banner from './index/Banner';
import Footer from './index/Footer';

export default {
  name: 'Contact',
  components: {
    Head,
    Navbar,
    Banner,
    Footer,
  },
  props: {},
  data() {
    return {
      videos: [
        {
          id: 936,
          title: '二十四节气里的中医养生智慧 大寒',
          cover: 'https://image.llts.com.cn/image/web/fa08a3a447222526d106cfcb5d946be1.jpg',
        },
        {
          id: 412,
          title: '关公提刀上灞桥',
          cover: 'https://image.llts.com.cn/image/web/5d51b04915a6ad36f438b464a8f509e2.jpg',
        },
        {
          id: 406,
          title: '庐州太极精编三十六式',
          cover: 'https://image.llts.com.cn/image/web/04a17470957742546d564c20d6f289aa.jpg',
        },
        {
          id: 264,
          title: '白肉PK红肉',
          cover: 'https://image.llts.com.cn/image/web/704d755166d037849ffea7ea1b9b95fe.jpg',
        },
        // {
        //   id: 1,
        //   title: '二十四节气里的中医养生智慧 大寒',
        //   cover: 'https://ylts.oss-cn-hangzhou.aliyuncs.com/video/offical/1.%E6%80%BB.jpg',
        // },
        // {
        //   id: 2,
        //   title: '老人健康过大年要“六防”——防操劳过累',
        //   cover: 'https://ylts.oss-cn-hangzhou.aliyuncs.com/video/offical/2.%E4%B8%80%E9%98%B2.jpg',
        // },
        // {
        //   id: 3,
        //   title: '老人健康过大年要“六防”——防烟酒过量',
        //   cover: 'https://ylts.oss-cn-hangzhou.aliyuncs.com/video/offical/3.%E4%BA%8C%E9%98%B2.jpg',
        // },
        // {
        //   id: 4,
        //   title: '老人健康过大年要“六防”——防饮食过饱',
        //   cover: 'https://ylts.oss-cn-hangzhou.aliyuncs.com/video/offical/4.%E4%B8%89%E9%98%B2.jpg',
        // },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
.main {
  width: 100%;
  // height:1000px;
  background-color: white;
  overflow: hidden;
}

.container {
  width: 1200px;
  // height:1000px;
  // background-color: pink;
  margin: 30px auto;
  overflow: hidden;
  text-align: center;
  margin-bottom: 90px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px 46px;

  .video-item {
    cursor: pointer;

    .cover {
      width: 577px;
      height: 325px;
      position: relative;

      .cover-image {
        width: 577px;
        height: 325px;
      }

      .mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.4) url(../assets/play.png) no-repeat center;
      }
    }

    .title {
      font-size: 20px;
      color: #3d3d3d;
      margin-top: 10px;
    }
  }
}
</style>
